// Lê/grava preferência de UI em localStorage com prefixo. Guarda ambientes
// sem localStorage (SSR/teste) devolvendo o default — exceção de UI permitida.
const PREFIX = 'localiza_pref_';

export function loadPref<T extends string>(key: string, fallback: T): T {
  try {
    if (typeof localStorage === 'undefined') return fallback;
    const v = localStorage.getItem(PREFIX + key);
    return (v as T) ?? fallback;
  } catch { return fallback; }
}

export function savePref(key: string, value: string): void {
  try {
    if (typeof localStorage === 'undefined') return;
    localStorage.setItem(PREFIX + key, value);
  } catch { /* silencioso: preferência de UI não é crítica */ }
}
